import React from 'react';
import { motion } from 'framer-motion';
import './Projects.css';

const projects = [
  {
    size: 'l',
    title: 'Thar Solar Park',
    location: 'Rajasthan, India',
    meta: '620 MW · Utility-scale',
    hue: 'linear-gradient(135deg, #FFB800 0%, #FF6B35 100%)',
    pattern: 'dunes',
  },
  {
    size: 'm',
    title: 'Faridabad Hybrid Grid',
    location: 'Haryana, India',
    meta: '48 MW + 120 MWh',
    hue: 'linear-gradient(135deg, #2E8FE5 0%, #1E5DAE 100%)',
    pattern: 'ice',
  },
  {
    size: 'm',
    title: 'Yamuna Floating Array',
    location: 'Delhi, India',
    meta: 'Floating array · 22 MW',
    hue: 'linear-gradient(135deg, #2EE6A7 0%, #2E8FE5 100%)',
    pattern: 'water',
  },
  {
    size: 'l',
    title: 'Noida Industrial Park',
    location: 'Uttar Pradesh, India',
    meta: '180 MW rooftop portfolio',
    hue: 'linear-gradient(135deg, #FF6B35 0%, #FFB800 100%)',
    pattern: 'city',
  },
  {
    size: 's',
    title: 'Aligarh Microgrids',
    location: 'Uttar Pradesh · 14 villages',
    meta: '8.2 MW distributed',
    hue: 'linear-gradient(135deg, #FFD166 0%, #FFB800 100%)',
    pattern: 'dots',
  },
  {
    size: 's',
    title: 'Gurugram EV Corridor',
    location: 'Haryana, India',
    meta: '38 DC stations · 12 MW',
    hue: 'linear-gradient(135deg, #1E5DAE 0%, #FF6B35 100%)',
    pattern: 'grid',
  },
];

export default function Projects() {
  return (
    <section id="projects" className="projects">
      <div className="container">
        <motion.div
          className="projects-head"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div>
            <span className="eyebrow">Field work</span>
            <h2 className="section-title">
              Projects <span className="accent">shaping skylines</span>.
            </h2>
          </div>
          <p className="section-lead">
            From utility parks to floating arrays, from city rooftops to remote microgrids —
            here's a slice of what we've deployed.
          </p>
        </motion.div>

        <div className="projects-grid">
          {projects.map((p, i) => (
            <motion.article
              key={p.title}
              className={`proj proj-${p.size}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
            >
              <div className="proj-art" style={{ background: p.hue }}>
                <div className={`proj-pattern pat-${p.pattern}`} />
                <div className="proj-shine" />
              </div>
              <div className="proj-body">
                <div className="proj-meta">{p.meta}</div>
                <h3>{p.title}</h3>
                <div className="proj-loc">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" width="14" height="14">
                    <path d="M12 22s-7-7-7-13a7 7 0 0114 0c0 6-7 13-7 13z" />
                    <circle cx="12" cy="9" r="2.5" />
                  </svg>
                  {p.location}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
